import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { OrgTab } from "@/pages/settings/OrgTab";
import { TeamTab } from "@/pages/settings/TeamTab";
import { ActivityTab } from "@/pages/settings/ActivityTab";
import { DataTab } from "@/pages/settings/DataTab";
import { ProfileTab } from "@/pages/settings/ProfileTab";

export default function SettingsPage() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "organization";
  const isOwner = user?.role === "owner";
  const canAudit = ["owner", "admin"].includes(user?.role);

  return (
    <div className="animate-fade-up">
      <h1 className="text-2xl font-semibold tracking-tight" data-testid="settings-title">Settings</h1>
      <p className="text-sm text-muted-foreground mt-1">Organization defaults, your team, and your account.</p>

      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })} className="mt-6">
        <TabsList className="rounded-xl flex-wrap h-auto">
          <TabsTrigger value="organization" data-testid="settings-tab-organization">Organization</TabsTrigger>
          <TabsTrigger value="team" data-testid="settings-tab-team">Team</TabsTrigger>
          {canAudit && <TabsTrigger value="activity" data-testid="settings-tab-activity">Activity</TabsTrigger>}
          {isOwner && <TabsTrigger value="data" data-testid="settings-tab-data">Data</TabsTrigger>}
          <TabsTrigger value="profile" data-testid="settings-tab-profile">Profile</TabsTrigger>
        </TabsList>
        <TabsContent value="organization" className="mt-6"><OrgTab /></TabsContent>
        <TabsContent value="team" className="mt-6"><TeamTab /></TabsContent>
        {canAudit && <TabsContent value="activity" className="mt-6"><ActivityTab /></TabsContent>}
        {isOwner && <TabsContent value="data" className="mt-6"><DataTab /></TabsContent>}
        <TabsContent value="profile" className="mt-6"><ProfileTab /></TabsContent>
      </Tabs>
    </div>
  );
}
